exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\ntable th[data-v-b5753634] {\n  font-weight: 400;\n}\ntable tbody tr[data-v-b5753634]:hover {\n  border: none;\n  transform: none;\n}\ntable tbody tr.noHover[data-v-b5753634]:hover {\n  border: none;\n  background-color: white;\n  transform: none;\n}\n.tr-size[data-v-b5753634] {\n  height: 40px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-b5753634","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/EventEdit/areaRules.vue
// module id = 1501
// module chunks = 0